export * from "../../base/store/getters";

export function get_empty_item(state) {
	return state.empty_item;
}
